import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import Heading from '../heading/heading';
import displayNames from '../displayNames';
import { dataHooks, sizeOptions } from './constants';
var ContextualDivider = function ContextualDivider(_ref) {
  var automationId = _ref.automationId,
    dataHook = _ref.dataHook,
    getClassName = _ref.getClassName,
    shouldTranslate = _ref.shouldTranslate,
    value = _ref.value,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    "data-aid": automationId,
    "data-hook": dataHook,
    className: getClassName('control-contextual-divider')
  }, /*#__PURE__*/React.createElement("hr", {
    className: "horizontal-line"
  }), /*#__PURE__*/React.createElement(Heading, {
    dataHook: dataHooks.label,
    shouldTranslate: shouldTranslate,
    appearance: size === sizeOptions.small ? 'h5' : 'h3'
  }, value), /*#__PURE__*/React.createElement("hr", {
    className: "horizontal-line"
  }));
};
ContextualDivider.displayName = displayNames.CONTEXTUAL_DIVIDER;
ContextualDivider.propTypes = {
  /** Value to be displayed as part of the divider */
  value: PropTypes.string.isRequired,
  /** Sets the font size of the text */
  size: PropTypes.oneOf(['small', 'large'])
};
ContextualDivider.defaultProps = {
  size: sizeOptions.large
};
export default compose(ContextualDivider);